import React from 'react';
import classNames from 'classnames';
import './styles.scss';

interface MiniBarProps {
    /** The value this bar represents. */
    value: number;
    /** The largest value across the set; the fill is `value / max`. */
    max: number;
    /** Optional override for the leading number (defaults to `value`). */
    label?: React.ReactNode;
    className?: string;
    /** Extra class on the fill element, e.g. to re-tone it. */
    barClassName?: string;
}

/**
 * A number followed by a horizontal bar whose fill is proportional to `max`.
 * Presentational only — the caller supplies the shared `max` so bars across a
 * column or list are comparable.
 */
const MiniBar: React.FC<MiniBarProps> = ({ value, max, label, className, barClassName }) => {
    const safeMax = max > 0 ? max : 1;
    const pct = Math.max(0, Math.min(100, (value / safeMax) * 100));
    return (
        <div className={classNames('rb-mini-bar', className)}>
            <span className="rb-mini-bar__value">{label ?? value}</span>
            <span className="rb-mini-bar__track">
                <span className={classNames('rb-mini-bar__fill', barClassName)} style={{ width: `${pct}%` }} />
            </span>
        </div>
    );
};

export default MiniBar;
